import { Box, Tooltip, Typography } from '@presov.sk/presov-ui-react';

type Props = {
  tooltip?: string;
};

export const ExplicitIcon: React.FC<Props> = ({ tooltip }) => {
  return (
    <Tooltip title={tooltip}>
      <Box
        width={12}
        height={12}
        display='flex'
        alignItems='center'
        justifyContent='center'
        bgcolor={'warning.main'}
      >
        <Typography
          variant='caption'
          fontWeight={'bold'}
          fontSize={9}
          color='white'
        >
          N
        </Typography>
      </Box>
    </Tooltip>
  );
};
